export const BOARD_ROWS = 20;
export const BOARD_COLS = 10;

export const PIECES = {
  I: {
    color: "cyan",
    rotations: [
      [[0,0],[0,1],[0,2],[0,3]],
      [[0,2],[1,2],[2,2],[3,2]],
      [[1,0],[1,1],[1,2],[1,3]],
      [[0,1],[1,1],[2,1],[3,1]],
    ],
  },
  J: {
    color: "blue",
    rotations: [
      [[0,0],[1,0],[1,1],[1,2]],
      [[0,1],[0,2],[1,1],[2,1]],
      [[1,0],[1,1],[1,2],[2,2]],
      [[0,1],[1,1],[2,0],[2,1]],
    ],
  },
  L: {
    color: "orange",
    rotations: [
      [[0,2],[1,0],[1,1],[1,2]],
      [[0,1],[1,1],[2,1],[2,2]],
      [[1,0],[1,1],[1,2],[2,0]],
      [[0,0],[0,1],[1,1],[2,1]],
    ],
  },
  O: {
    color: "yellow",
    rotations: [
      [[0,1],[0,2],[1,1],[1,2]],
      [[0,1],[0,2],[1,1],[1,2]],
      [[0,1],[0,2],[1,1],[1,2]],
      [[0,1],[0,2],[1,1],[1,2]],
    ],
  },
  S: {
    color: "green",
    rotations: [
      [[0,1],[0,2],[1,0],[1,1]],
      [[0,1],[1,1],[1,2],[2,2]],
      [[1,1],[1,2],[2,0],[2,1]],
      [[0,0],[1,0],[1,1],[2,1]],
    ],
  },
  T: {
    color: "purple",
    rotations: [
      [[0,1],[1,0],[1,1],[1,2]],
      [[0,1],[1,1],[1,2],[2,1]],
      [[1,0],[1,1],[1,2],[2,1]],
      [[0,1],[1,0],[1,1],[2,1]],
    ],
  },
  Z: {
    color: "red",
    rotations: [
      [[0,0],[0,1],[1,1],[1,2]],
      [[0,2],[1,1],[1,2],[2,1]],
      [[1,0],[1,1],[2,1],[2,2]],
      [[0,1],[1,0],[1,1],[2,0]],
    ],
  },
};

export const PIECE_TYPES = Object.keys(PIECES);

export const createEmptyBoard = () =>
  Array.from({ length: BOARD_ROWS }, () => Array(BOARD_COLS).fill(null));

export const createBag = () => {
  const bag = [...PIECE_TYPES];
  for (let i = bag.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [bag[i], bag[j]] = [bag[j], bag[i]];
  }
  return bag;
};

export const spawnPiece = (type) => ({
  type,
  rotation: 0,
  row: -1,
  col: 3,
});

export const getCells = (piece) =>
  PIECES[piece.type].rotations[piece.rotation].map(([r, c]) => [
    piece.row + r,
    piece.col + c,
  ]);

export const isValidPosition = (board, piece) =>
  getCells(piece).every(([row, col]) => {
    if (col < 0 || col >= BOARD_COLS || row >= BOARD_ROWS) return false;
    if (row < 0) return true;
    return !board[row][col];
  });

export const getGhostRow = (board, piece) => {
  let ghost = { ...piece };
  while (isValidPosition(board, { ...ghost, row: ghost.row + 1 })) {
    ghost = { ...ghost, row: ghost.row + 1 };
  }
  return ghost.row;
};

export const mergePiece = (board, piece) => {
  const next = board.map((row) => [...row]);
  let toppedOut = false;

  getCells(piece).forEach(([row, col]) => {
    if (row < 0) {
      toppedOut = true;
      return;
    }
    if (row < BOARD_ROWS && col >= 0 && col < BOARD_COLS) {
      next[row][col] = piece.type;
    }
  });

  return { board: next, toppedOut };
};

export const clearLines = (board) => {
  const remaining = board.filter((row) => row.some((cell) => !cell));
  const cleared = BOARD_ROWS - remaining.length;
  const emptyRows = Array.from({ length: cleared }, () =>
    Array(BOARD_COLS).fill(null)
  );
  return { board: [...emptyRows, ...remaining], cleared };
};

export const scoreForClear = (lines, level) => {
  const base = [0, 100, 300, 500, 800][lines] || 0;
  return base * level;
};

export const levelForLines = (lines) => Math.floor(lines / 10) + 1;

export const dropDelayForLevel = (level) =>
  Math.max(90, 850 - (level - 1) * 65);

export const rotateWithKick = (board, piece, direction = 1) => {
  const rotationCount = PIECES[piece.type].rotations.length;
  const nextRotation =
    (piece.rotation + direction + rotationCount) % rotationCount;

  const kicks = [0, -1, 1, -2, 2];
  for (const offset of kicks) {
    const candidate = {
      ...piece,
      rotation: nextRotation,
      col: piece.col + offset,
    };
    if (isValidPosition(board, candidate)) return candidate;
  }
  return piece;
};
